/**
 * @copyright Copyright 2019 Epic Systems Corporation
 * @file noOp internal helper function
 * @author Roland Scott
 * @module react-async-hook\internal\use-async\no-op
 */

/**
 * A function that does nothing.
 */
export function noOp(..._args: any[]): void {
	return;
}
